export default __webpack_public_path__ + "static/moon_bunnies_b-16283bf2a3a09d44226a1b2903dbbcea.jpg";